import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import find from 'lodash/find'

import * as grant from '../../../actions/userdetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class Grant extends Component {
    state = {
        device_count: 0
    };

    handleChange = event => {
        this.setState({ device_count: event.target.value });
    };
    handleRequestClose = () => {
        this.state.device_count = 1;
        this.props.closeDialog();
    };

    setData = () => {
        this.props.actions.grant(this.props.id, this.state.device_count);
    };

    render() {
        const { id, userDetails,count } = this.props;
        let message = null
        if ((userDetails && userDetails.grantStatus)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (userDetails && userDetails.grantResult) {
            // console.log('grant this.props', this.props)
            this.props.actions.getUserDetailsList();
            this.props.closeDialog();
            this.state.device_count = 1;
        }
        let _GrantList = null
        // console.log('Grant id', id)
        var arr = [];
        if (id) {
            console.log(count);             
             for (var i = Number(count)+1; i <= 6; i++) {
                //console.log(arr);
               arr.push(i);              
            }
            console.log(arr);
             _GrantList = arr.map(id => (
                <MenuItem key={id} value={id}
                    style={{ fontWeight: '500' }}>
                    {id}
                </MenuItem>
            ))
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Grant User Device</span>
                    </DialogTitle>
                    <DialogContent>
                        {message}
                        <div className="row p-4">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-12">
                                        Please select the required number of devices to be granted
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <FormControl className="w-100 mb-2 col-md-12">
                                            <InputLabel htmlFor="age-simple">Number of devices</InputLabel>
                                            <Select
                                                value={this.state.device_count}
                                                onChange={this.handleChange}
                                                // onClick={(e) => this.setState({age: e.target.value})}
                                                input={<Input id="age-simple" />}
                                            >
                                                {_GrantList}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Grant</Button>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(grant, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Grant);


// WEBPACK FOOTER //
// ./app/userdetails/userlist/grant.js